<template>
<div>
  <DataNavigation></DataNavigation>
  <!-- <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt> -->
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">股票信息</p>
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '领域选择'">
                <div class="screen_tle" @click="screenTle.tag_arr = !screenTle.tag_arr">
                  <span>领域选择</span>
                  <Icon type="md-add" v-if="!screenTle.tag_arr" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.tag_arr">
                  <ul class="scr_attention">
                    <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                      <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                        <div class="scr_att_tle">
                          <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                          <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                          <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                        </div>
                        <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                          <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </div>
                      </li>
                    </CheckboxGroup>
                  </ul>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '上市交易所'">
                <div class="screen_tle" @click="screenTle.market_id = !screenTle.market_id">
                  <span>上市市场</span>
                  <Icon type="md-add" v-if="!screenTle.market_id" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.market_id">
                  <RadioGroup v-model="params.market_id" vertical  @on-change="clearGetList">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio v-for="item,index in stock_market" :label="item.id" :key="index" v-if="index < 5"><span>{{item.name}}</span></Radio>
                    <Radio label="-1"><span>其他</span></Radio>
                  </RadioGroup>
                </div>
              </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '上市时间'">
                <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                <span>上市时间</span>
                <Icon type="md-add" v-if="!screenTle.time" />
                <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.time">
                <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                    <span>{{item}}</span>
                    </Radio>
                    <Radio label="zdy"><span>自定义</span></Radio>
                </RadioGroup>
                <div class="zdy_time" v-if="selTime == 'zdy'">
                    <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                </div>
                </div>
            </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <p class="info">数据更新日期：{{latest_date}}  交易日：{{latest_date}}</p>
          <template>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage($event, true)" />
            </div>
          </template>
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  stockList
} from '../../service'
import {
  remove
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import DataNavigation from './components/DataNavigation.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    DataNavigation
  },
  data() {
    return {
      listName: '股票信息',
      latest_date: '',
      listColumns: [
        {
            type: 'index',
            width: 60,
            align: 'center',
            title: '序号'
        },
        {
          title: '代码',
          width: 66,
          render: (h, params) => {
            if(params.row.entity_uid) {
                if(params.row.entity_type == '0'
                ||params.row.entity_type == '1'
                ||params.row.entity_type == '2'
                ||params.row.entity_type == '3'){
                    return h('a',{
                    on: {
                        click: () => {
                        this.goEntityDetail(params.row.entity_uid, params.row.entity_type,{ active_name:'shareprice'})
                        }
                    },
                    class: {
                        'dec-clamp': true
                    }
                    },  params.row.code)
                } else {
                    return h('div', params.row.code)
                }
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '名称',
          width: 78,
          render: (h, params) => {
            if(params.row.entity_uid) {
                if(params.row.entity_type == '0'
                ||params.row.entity_type == '1'
                ||params.row.entity_type == '2'
                ||params.row.entity_type == '3'){
                    return h('a',{
                    on: {
                        click: () => {
                        this.goEntityDetail(params.row.entity_uid, params.row.entity_type,{ active_name:'shareprice'})
                        }
                    },
                    class: {
                        'dec-clamp': true
                    }
                    },  params.row.entity_short_name)
                } else {
                    return h('div', params.row.entity_short_name)
                }
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '市值',
          width: 76,
          render: (h, params) => {
            return h('span', filter.amountPrecise2(params.row.TC_value, params.row.currency_id, this.meta.unit))
          }
        },
        {
          // type: 'html',
          title: '最新价',
          // renderHeader: (h, params) => {
          //   return h('p', {
          //     domProps:{
          //       innerHTML: '昨日<br/>收盘价'
          //     }
          //   })
          // },
          width: 58,
          render: (h, params) => {
            return h('span', params.row.close?Number(params.row.close).toFixed(2):'--')
          }
        },
        {
          title: '涨跌幅',
          width: 60,
          render: (h, params) => {
            return h('span', params.row.pctChg?params.row.pctChg+'%':'--')
          }
        },
        {
          title: '涨跌额',
          width: 58,
          render: (h, params) => {
            return h('span', filter.empty(params.row.zde))
          }
        },
        {
          title: '成交量',
          width: 66,
          render: (h, params) => {
            return h('span', params.row.volume?filter.amountJustPrecise2(params.row.volume/100)+'手':'--')
          }
        },
        {
          title: '成交额',
          width: 84,
          render: (h, params) => {
            return h('span', filter.amountPrecise2(params.row.amount, params.row.currency_id, this.meta.unit))
          }
        },
        {
          title: '振幅',
          width: 58,
          render: (h, params) => {
            return h('span', params.row.amplitude?params.row.amplitude+'%':'--')
          }
        },
        {
          title: '最高',
          width: 56,
          render: (h, params) => {
            return h('span', params.row.high?Number(params.row.high).toFixed(2):'--')
          }
        },
        {
          title: '最低',
          width: 56,
          render: (h, params) => {
            return h('span', params.row.low?Number(params.row.low).toFixed(2):'--')
          }
        },
        {
          title: '换手率',
          width: 64,
          render: (h, params) => {
            return h('span', params.row.turn?params.row.turn+'%':'--')
          }
        },
        {
          title: '市盈率',
          width: 64,
          render: (h, params) => {
            return h('span', filter.empty(params.row.peTTM))
          }
        },
        {
          title: '市净率',
          render: (h, params) => {
            return h('span', filter.empty(params.row.pbMRQ))
          }
        }
      ],
      params: {
        year:"",
        s_time:"",
        e_time:"",
        keyword:"",
        sort_type:0,
        market_id:"",
        tag_arr:[],
        page:1,
        fetch_size: 0
      },
      screen_dropdown: ['全部', '领域选择', '上市交易所', '上市时间'],
      //筛选条件是否展开
      screenTle: {
        tag_arr: false,
        market_id: false,
        time: false
      },
    //   //不限
      checkAll: {
        tag_arr: true
      },
    //   showAllTag: false,
      // showAllMarket: false,

      sort_id: 0,
      sort_list: [
        {id: 0, name: '按涨跌幅降序'},
        {id: 1, name: '按涨跌幅升序'}
      ],

    //   数组
    stock_market: []
    }
  },
  computed: {
    haveOption() {
       let optionTag = [],
        optionYear = [],
        optionStart = [],
        optionEnd = [],
        optionMarket = [],
        optionKeyword = []
      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: filter.dealName(a, this.hot_tag_map),
          value: a
        })
      })
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        optionEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.keyword) {
        optionKeyword = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      if (this.params.market_id) {
        optionMarket = {
          type: 'market_id',
          name: this.params.market_id == '-1'? '其他':filter.dealName(this.params.market_id, this.stock_market),
          value: this.params.market_id
        }
      }

      return [].concat(
        optionTag,
        optionYear,
        optionStart,
        optionEnd,
        optionMarket,
        optionKeyword
      )
    }
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await stockList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
            this.$set(this.$data, 'total', res.count)
            this.latest_date = res.latest_date
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        year:"",
        s_time:"",
        e_time:"",
        keyword:"",
        sort_type:0,
        market_id:"",
        tag_arr:[],
        page:1,
        fetch_size: 0
      }
      this.checkAll = {
        tag_arr: true
      }
      this.search_ipt = ''
      this.selTime = ''
      this.params.page = 1
      this.getEntityList()
    }
  },
  created() {
    this.getMeta(true)
    this.getMeta2(['stock_market','unit'], () => {
        this.stock_market = this.meta.stock_market
    })
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    // this.$store.commit('updateOrgParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
.info
  margin-top: 10px
  text-align: right
  font-size: 12px
  commonColor(#797B83,#999999)
.list_div 
  >>>.ivu-table-wrapper 
    .ivu-table-cell
      padding-left: 5px
      padding-right: 5px
</style>
